import React from "react";


import styled from "styled-components";

import FormHOC from "hoc/FilltersForm";
import { debounce } from "utils";
import Text from "components/Form/Text";

import { Form, Schema } from "rsuite";

const { StringType } = Schema.Types;

const filtersModel = Schema.Model({
    str: StringType().maxLength(256, "The maximum is only 256 characters."),
});


const AccessListExceptionFilter = ({ onChange, defaultFilters }) => {
    const handleChange = (formValues) => {
        onChange(formValues);
    };

    return (
        <>
            <Form
                className="access_list_exception_filter"
                model={filtersModel}
                layout="inline"
                onChange={debounce((value) => {
                    handleChange(value);
                }, 400)}
                formDefaultValue={defaultFilters}
            >
                <StyledTextField
                    name="str"
                    placeholder="Origin/Origin prefix/Destination/Sender ID"
                />
            </Form>
        </>
    );
};

export default FormHOC(AccessListExceptionFilter, filtersModel, 300);

const StyledTextField = styled(Text)`
    &&& {
        width: 100%;
        min-width: 300px;
    }
`;